const config = {
  defaultPage: '/myWorkspace',
  workspace: {
    paymentInfoEnable: false,
    downloadCSVEnable: false,
    editable: false,
    addWorksapceEnable: true,
    addMemberEnable: false,
    maxMemberEditable: true,
    expiredAtEditable: true,
    statusEditable: true,
  },
}

export default config
